import React,{ useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import {Button,Card,Form,Container,Row,Col} 
from "react-bootstrap";
import { confirmAlert } from 'react-confirm-alert'; 
import 'react-confirm-alert/src/react-confirm-alert.css'; 
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import DataTable from "react-data-table-component";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faEdit,faDeleteLeft} from "@fortawesome/free-solid-svg-icons";
import "assets/css/grid.css";
import {MensajeAlerta} from '../components/Messages/MensajeAlerta';
import "react-datetime/css/react-datetime.css";
import 'moment/locale/es';
import { useProyectos } from 'hooks/useProyectos';

const paginacionOpciones={
    rowsPerPageText:'Número elementos',
    rangeSeparatorText:'de',
    selectAllRowsItemsText:'Todos'
}
function ListadoProyectos(){
   
    const 
    { 
      proyectos,
      getProyectos,
      insertProyecto,
      updateRespuestaIngresarProyecto,
      respuestaIngresarProyecto,
      disabledProyecto} = useProyectos();
    const [isChangedElements,setChange]=useState(false);
    const [proyectoPorIngresar, setProyectoPorIngresar] = useState({});
    const [disable, setDisable] = useState(false);

    const columnas=[
    {
        name:'Valor',
        selector: row => row.Valor,
        sorteable:true,
        omit:true
    },
    {
        name:'Nombre',
        selector: row => row.Nombre,
        sorteable:true
               
    },
    {
      name:'Descripción',
      selector: row => row.Descripcion,
      sorteable:true
             
  },
    ,
    {
       
		cell: row => (
            <>
           
            <a href={'EditarProyecto/'+row.Valor} rel="noopener noreferrer">
            	<FontAwesomeIcon icon={faEdit} />
               
            </a>
            &nbsp;&nbsp;&nbsp;
            <a href="#" onClick={event=>onDisabled(row.Valor)} rel="noopener noreferrer" title='Eliminar'>
            	<FontAwesomeIcon icon={faDeleteLeft} />
            </a>
           
            </>       
        ),
    }
    
    ];
    const crearProyecto = async() => {
      setChange(false);
      const resp=await insertProyecto(proyectoPorIngresar);
      if(resp?.success)
      {
        setProyectoPorIngresar({'Nombre':'','Descripcion':''});
                    
      }
      setChange(true);
    };
    const onDisabled=async n=>{
    
      confirmAlert({
          title: '',
          message: '¿Seguro desea eliminar proyecto?',
          buttons: [
            {
              label: 'Si',
              onClick: async() => {
                await disabledProyecto(n);
                setDisable(true)}
            },
            {
              label: 'No'
              
            }
          ]
        });
  
  }

    useEffect( () => {
      async function proyectosFuncion(){
        await getProyectos();
      }
      proyectosFuncion();
    }, []);
  
    useEffect( () => {
      async function proyectosFuncion(){
        await updateRespuestaIngresarProyecto();  
        await getProyectos();
      }
      proyectosFuncion();
      
    }, [isChangedElements]);

    useEffect( () => {
      if(disable){
          
          async function proyectosFuncion(){
            getProyectos();
          }
          proyectosFuncion();
          setDisable(false)

      }
      

      
  }, [disable]);
  
    return (
            <>
             <Container fluid>
              <Row>
                <Col xs="12">
                  <Card className="strpied-tabled-with-hover">
                    <Card.Header>
                        <Card.Title as="h4">Listado de proyectos</Card.Title>
                        <p className="card-category">
                          En esta sección puede gestionar los proyectos</p>
                    </Card.Header>
                    <Card.Body className="table-full-width table-responsive px-0">
                    
                        <div className="button-container mr-auto ml-auto">
                        
                          <Tabs
                          defaultActiveKey="1"
                          id="uncontrolled-tab-example"
                          className="mb-3"
                          style={{marginLeft:0}}
                          >   
                            <Tab eventKey={1} title={'Listado Proyectos'}>
                              <div className='table-responsive'>
                                <DataTable
                                columns={columnas}
                                data={proyectos}
                                pagination
                                paginationComponentOptions={paginacionOpciones}
                                fixedHeader
                                fixedHeaderScrollHeight='600px'
                                noDataComponent="No hay elementos para mostrar"
                                striped={true}
                              />
                              </div>

                            </Tab>
                            <Tab eventKey={2} title={'Agregar Proyecto'} style={{marginLeft:2,marginRight:2}}>
                                
                                <Row>
                                  <Col xs="6">
                                    <label>Nombre</label>
                                    <Form.Control
                                    value={proyectoPorIngresar?.Nombre}
                                    placeholder=""
                                    type="text"
                                    onChange={(e,prop) => { 
                                      setProyectoPorIngresar({...proyectoPorIngresar,['Nombre']:e.target.value});
                                    }}
                                    rows={12}>
                                    </Form.Control>
                                  </Col>
                                  <Col xs="6">
                                    <label>Fecha Inicio</label>
                                    <Form.Control
                                    type="date"
                                    onChange={(e,prop) => { 
                                      setProyectoPorIngresar({...proyectoPorIngresar,['FechaInicio']:e.target.value});
                                    }}
                                    placeholder=""
                                    value={proyectoPorIngresar?.FechaInicio?.substring(0,10)}
                                    >
                                    </Form.Control>
                                  </Col>
                                </Row>
                                <Row>
                                  <Col xs="6">
                                    <label>Fecha Término</label>
                                    <Form.Control
                                    type="date"
                                    onChange={(e,prop) => { 
                                      setProyectoPorIngresar({...proyectoPorIngresar,['FechaTermino']:e.target.value});
                                    }}
                                    placeholder=""
                                    value={proyectoPorIngresar?.FechaTermino?.substring(0,10)}
                                    >
                                    </Form.Control>
                                  </Col>
                                </Row>
                           
                            <Row>
                                <Col xs="12">
                            
                                <label>Descripción</label>
                                <Form.Control
                                    value={proyectoPorIngresar?.Descripcion}
                                    placeholder=""
                                    type="textarea"
                                    as="textarea"
                                    onChange={(e,prop) => { 
                                      setProyectoPorIngresar({...proyectoPorIngresar,['Descripcion']:e.target.value});
                                    }}
                                    rows={12}>
                                </Form.Control>
                              
                                </Col>
                              
                            </Row>
                            <MensajeAlerta mensajeTexto={respuestaIngresarProyecto.mensajeTexto} estado={respuestaIngresarProyecto.estado} />
                            <Row>
                                <Col xs="6">
                                </Col>
                                <Col xs="6">
                              <br></br>
                                <Button
                                    className="btn-fill pull-right"
                                    type="submit"
                                    variant="info"
                                    onClick={(e)=>{
                                        e.preventDefault();
                                        crearProyecto();
                                    }}
                                  >
                                Ingresar Proyecto
                              </Button>
                              <br></br>
                                </Col>
                            </Row>
                            </Tab>
                          </Tabs>
                        
                        </div>
                      </Card.Body>
                  </Card>
                </Col>
              </Row>
            </Container>
            </>
        )
}
export default ListadoProyectos;